export const HAS_LIFE = "HAS_LIFE"
export const NO_LIFE = "NO_LIFE"